export default "__VITE_ASSET__A$E4$0$A__"